/* Customer reviews carousel: Swiper is only downloaded when the section gets close to the viewport. */
(function () {
  var pending = null;

  function loadSwiper(src, done) {
    if (typeof window.Swiper !== 'undefined') return done();
    if (pending) { pending.push(done); return; }
    pending = [done];
    var script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.onload = function () {
      var queue = pending || [];
      pending = null;
      queue.forEach(function (fn) { fn(); });
    };
    script.onerror = function () { pending = null; };
    document.head.appendChild(script);
  }

  function initSection(sectionEl) {
    if (sectionEl.dataset.crInit) return;
    var swiperEl = sectionEl.querySelector('.customer-reviews-swiper');
    if (!swiperEl || typeof window.Swiper === 'undefined') return;

    var swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      autoHeight: true,
      navigation: false,
      centeredSlides: false,
      centeredSlidesBounds: false,
      allowTouchMove: false
    });

    sectionEl.querySelectorAll('.custom-prev-customer-reviews').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        swiper.slidePrev();
      });
    });
    sectionEl.querySelectorAll('.custom-next-customer-reviews').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        swiper.slideNext();
      });
    });

    sectionEl.dataset.crInit = '1';
  }

  function start(sectionEl) {
    var src = sectionEl.getAttribute('data-swiper-src');
    if (!src) return;
    loadSwiper(src, function () { initSection(sectionEl); });
  }

  function setup() {
    var sections = document.querySelectorAll('#customer-reviews-carousel:not([data-cr-init])');
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      sections.forEach(start);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        start(entry.target);
      });
    }, { rootMargin: '600px 0px' });

    sections.forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', setup);
})();
